"use client";

import NextImage, { type ImageProps as NextImageProps } from "next/image";
import NextLink, { type LinkProps as NextLinkProps } from "next/link";

import {
	ProductFiftyFifty,
	ProductFiftyFiftyProps
} from "@/composite/ProductFiftyFifty";
import type { ComplexCardReference } from "@/types";
import { resolveImageProps } from "@/app/utilities/images";

import { type FiftyFiftyBlockProps as FiftyFiftyBlockServerProps } from ".";

export interface FiftyFiftyBlockProps extends FiftyFiftyBlockServerProps {
	complexCardData?: ComplexCardReference;
}

/**
 * Product 50-50 block component
 */
export function FiftyFiftyBlock({
	complexCardData,
	theme
}: FiftyFiftyBlockProps): JSX.Element {
	const { headline, description, cta_group, multimedia_assets } =
		complexCardData || {};

	return (
		<ProductFiftyFifty<NextImageProps, NextLinkProps>
			theme={theme as ProductFiftyFiftyProps["theme"]}
			headline={
				headline?.headline
					? {
							children: headline?.headline,
							tag: headline?.headline_tag
						}
					: undefined
			}
			description={description}
			cta={
				cta_group?.length
					? {
							component: NextLink,
							href: cta_group[0]?.cta.link.href ?? "",
							children: cta_group[0]?.cta.link.title
						}
					: undefined
			}
			assets={multimedia_assets?.asset_blocks
				.slice(0, 3)
				.map((asset) => ({
					type: asset.blockType === "image_asset" ? "image" : "video",
					image: {
						component: NextImage,
						...resolveImageProps("16:9", asset)
					}
				}))}
		/>
	);
}
